import apiClient from '@/shared/api/client';
import type { ApiResponse } from '@/shared/api/types';

type FlagsResult = { id: string; featureFlags: Record<string, boolean> };

export const rolloutApi = {
  setAgentTasksFlag: async (
    practiceId: string,
    agentType: string,
    enabled: boolean,
  ): Promise<FlagsResult> => {
    const { data } = await apiClient.patch<ApiResponse<FlagsResult>>(
      `/agency/rollout/practices/${practiceId}/agent-tasks`,
      { agentType, enabled },
    );
    return data.data;
  },

  setInternalFlag: async (practiceId: string, internal: boolean): Promise<FlagsResult> => {
    const { data } = await apiClient.patch<ApiResponse<FlagsResult>>(
      `/agency/rollout/practices/${practiceId}/internal`,
      { internal },
    );
    return data.data;
  },
};
